// extracted by mini-css-extract-plugin
export default {"itemTitle":"styles_itemTitle__nmexB","sectionTitle":"styles_sectionTitle__jHrxA"};